import React, { useEffect, useState, useRef } from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import axios from "../helper/axios";

import DOMPurify from 'dompurify'

export default function Delivery() {

  const [allCms, setAllCms] = useState([]);

  const apiData = async () => {
    const res = await axios.post("/getcms");
    console.log(res?.status);
    if (res.status === 200) {
      setAllCms(res?.data);
    } else {
      setAllCms()
    }
  }

  useEffect(() => {
    apiData();
  }, []);

  const sanitizedData = () => ({
    __html: DOMPurify.sanitize(allCms)
  })

  const ref = useRef(null);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };
  useEffect(() => {
    scrollToTop();
  }, [])

  return (
    <>
      <Header />
      <div className='container mx-auto pt-32'>
        <div className="Cart mt-heading">
          <div className="p-0-mobile container wishlist">
            <div className="">
              <div className="CartItem fade-in-down">
                {allCms?.length > 0 && allCms?.map((dt, index) => (
                  dt.slugTitle === "delivery" ? (
                    <div className="CartItem__content inner-pages delivery">
                      <h2 className='privacy-heading'><strong>{dt.pageTitle}</strong></h2>
                      <div
                        dangerouslySetInnerHTML={{ __html: dt.pageContent }}
                      />
                    </div>
                  ) : null
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
